import { useEffect } from "react";
import { Header } from "@/components/aklive/Header";
import { Footer } from "@/components/aklive/Footer";
import { Marquee } from "@/components/aklive/Marquee";
import { Hero } from "@/components/aklive/sections/Hero";
import { Pivot } from "@/components/aklive/sections/Pivot";
import { Purpose } from "@/components/aklive/sections/Purpose";
import { Process } from "@/components/aklive/sections/Process";
import { Moments } from "@/components/aklive/sections/Moments";
import { WorkProof } from "@/components/aklive/sections/WorkProof";
import { Manifesto } from "@/components/aklive/sections/Manifesto";
import { FinalCTA } from "@/components/aklive/sections/FinalCTA";

export default function Ethos() {
  useEffect(() => {
    document.title = "AKLIVE — Ethos";
  }, []);

  return (
    <div className="bg-paper text-left text-ink">
      <Header />
      <main id="main" className="overflow-x-clip">
        <Hero />
        <div className="mt-24 md:mt-40">
          <Marquee />
        </div>
        <Pivot />
        <Purpose />
        <Process />
        <Moments />
        <WorkProof />
        <Manifesto />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
